'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'calendar-days';
var width = 448;
var height = 512;
var aliases = ["calendar-alt"];
var unicode = 'f073';
var svgPathData = 'M128 0l0 64 192 0 0-64 32 0 0 64 96 0 0 416-448 0 0-416 96 0 0-64 32 0zM416 96l-384 0 0 64 384 0 0-64zm0 96l-96 0 0 64 96 0 0-64zm0 96l-96 0 0 64 96 0 0-64zm0 96l-96 0 0 64 96 0 0-64zM288 352l0-64-128 0 0 64 128 0zM160 384l0 64 128 0 0-64-128 0zm-32-32l0-64-96 0 0 64 96 0zM32 384l0 64 96 0 0-64-96 0zm0-128l96 0 0-64-96 0 0 64zm128 0l128 0 0-64-128 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendarDays = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;